export default __webpack_public_path__ + "static/media/ed2.8660a107.svg";